import { useEffect, useState } from "react";

const makeData = (regio: string) => ({ label: regio, value: regio });

const useAreaHook = (newAreas?: string[]) => {
  const defaultAreas = ["Namen", "Limburg", "Doornik"];
  const set = new Set([...defaultAreas, ...(newAreas || [])]);

  const uniqueAreas = Array.from(set);

  const [areas, setAreas] = useState(uniqueAreas.map((area) => makeData(area)));

  useEffect(() => {
    setAreas(uniqueAreas.map((area) => makeData(area)));
  }, [newAreas]);

  return { areas, setAreas };
};

export default useAreaHook;
